import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import useCommon from "hooks/useCommon";
import { FaExclamationTriangle } from "react-icons/fa";

const ConfirmDeleteUserDialog = ({ open, userName, onClose, onConfirm }) => {
  const { STORE } = useCommon();
  const { deleteLoading } = STORE((state) => state.user);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      {/* <DialogTitle>
        <VuiTypography variant="h6" >
          Delete User
        </VuiTypography>
      </DialogTitle> */}

      <DialogContent>
        <VuiBox textAlign="center" py={1}>
          <VuiBox>
            <FaExclamationTriangle size={32} color="#ff4d4f" />

            <VuiTypography variant="body2" mt={2}>
              Are you sure you want to permanently delete <strong>{userName}</strong>?
            </VuiTypography>
          </VuiBox>

          <VuiTypography variant="caption">This action cannot be undone.</VuiTypography>
        </VuiBox>
      </DialogContent>

      <DialogActions>
        <VuiButton variant="outlined" color="primary" onClick={onClose}>
          Cancel
        </VuiButton>

        <VuiButton color="error" onClick={onConfirm} disabled={deleteLoading}>
          {deleteLoading ? "Deleting..." : "Delete User"}
        </VuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteUserDialog;
